import useControllerState from '@common/hooks/useControllerState'

// Mobile (native + mobile-web) has no MV3 service worker. The real
// WalletStateController is booted into the in-process ControllerStore by the
// WebViewWorker, so surface its state from there. The web extension uses the
// real `.ts` sibling backed by WalletStateControllerContext instead.
//
// This used to return `{}`, which left every mobile consumer (themeContext,
// Avatar, onboarding, …) reading `undefined` — e.g. the theme dropdown showed
// "Light" and never reflected or persisted the chosen theme.
//
// Read straight from useControllerState (not useController) so the subscription
// is active immediately: useController only subscribes lazily on first `.state`
// access via a render-phase setState, which left live `setThemeType` updates not
// re-rendering. Fall back to `{}` until the store has the controller's state so
// consumers' destructures don't crash.
export default function useWalletStateController(): any {
  const { state } = useControllerState({ id: 'WalletStateController' })
  return state || {}
}
